module.exports = __webpack_public_path__ + "img/feature10.a89747a.png";